import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrainingTypesActionHandler,
  getUserDistributionReportActionHandler,
  getUserShotClassReportActionHandler,
} from "../../../../store/actions/actionHandlers/reportActionHandler";
import Dropdown from "../../../../components/Common/ReactForm/Dropdown/Dropdown";
import classes from "./UserTabularReport.module.scss";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useNavigate } from "react-router";
import { tabularReport } from "../../../../utils/mainTabs/reports/tabularReport";
import { useFetchData } from "../../../../hooks/useFetchData";
import Button from "../../../../components/Common/Button/Button";
import { useCallback } from "react";
import Modal from "../../../../components/Common/Modal/Modal";
import { userTabularModalReport } from "../../../../utils/mainTabs/reports/tabularReport/userTabularModalReport";
import NoDataFoundIcon from "../../../../components/Common/SvgIcons/ReportIcons/NoDataFoundIcon";
import { FormattedMessage, injectIntl } from "react-intl";
import Input from "../../../../components/Common/Input/Input";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { dateFormatyyyymmdd } from "../../../SocialPage/PollManagement/DistributePoll/DistributePollForm/DistributePollForm";
import InputHookForm from "../../../../components/Common/Input/Input";

export const userTabularReportSchema = yup.object().shape({
  userName: yup.string(),
  fromDate: yup.string(),
  toDate: yup.string(),
  // TrainingTypes: yup
  //   .array(
  //     yup.object().shape({
  //       Name: yup.string(),
  //       TypeId: yup.number(),
  //     })
  //   )
  //   // .min(1, "Select at least One User to proceed")
  //   .max(15, "Maximum 15 Training Types are allowed"),
});

const UserTabularReport = ({ intl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const methods = useForm({
    resolver: yupResolver(userTabularReportSchema),
    defaultValues: {
      userName: "",
      fromDate: "",
      toDate: "",
    },
  });
  const {
    formState: { errors },
    reset,
  } = methods;
  const pageSize = 20;
  const pageNumber = 1;
  const { columns } = tabularReport;
  const reportState = useSelector((state) => state.reportReducer);
  const { trainingTypes } = reportState;
  const [userId, setUserId] = useState(0);
  const [trainingTypesOptions, setTrainingTypesOptions] = useState([]);
  const [fromDate, setFromDate] = useState("none");
  const [toDate, setToDate] = useState("none");
  const [user, setUser] = useState("none");
  const [selectedTrainings, setSelctedTrainings] = useState("none");
  const [reportMode, setReportMode] = useState("View");
  const [tableColumns, setTableColumns] = useState([]);
  const [selectedTrainingIds, setSelectedTrainingIds] = useState("none");
  const [loader, setLoader] = useState(false);
  const [fromMinDate, setFromMinDate] = useState(null);
  const [toMinDate, setToMinDate] = useState(null);
  const [fromMaxDate, setFromMaxDate] = useState(
    dateFormatyyyymmdd(new Date())
  );
  const [toMaxDate, setToMaxDate] = useState(dateFormatyyyymmdd(new Date()));

  const { columns: modalColumns } = userTabularModalReport;
  useEffect(() => {
    const trainingOptions = trainingTypes?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    setTrainingTypesOptions(trainingOptions);
  }, [trainingTypes]);

  const onTrainingSelected = (selected) => {
    // debugger;
    let trainingTypeSelected = "";
    selected?.forEach((data, index) => {
      trainingTypeSelected = `${trainingTypeSelected + data?.value}${
        selected?.length !== index + 1 ? "," : ""
      }`;
    });
    setSelectedTrainingIds(trainingTypeSelected);
    setSelctedTrainings(selected);
  };

  useEffect(() => {
    dispatch(getTrainingTypesActionHandler());
  }, [dispatch]);

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setUserDistributionReport,
      setTempUserDistributionReport,
      setTotalRows
    ) =>
      getUserDistributionReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setUserDistributionReport,
        setTempUserDistributionReport,
        setTotalRows,
        fromDate,
        toDate,
        user,
        selectedTrainingIds,
        reportMode,
        setLoader
      ),
    pageSize
  );

  const {
    data: modalData,
    setData: setModalData,
    updatedData: updatedModalData,
    setUpdatedData: setModalUpdatedData,
    totalRows: setModalTotalRows,
    handleCurrentPage: handlerModalCurrentPage,
    handleSearchQuery: handleModalSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setUserShotClassReport,
      setTempUserShotClassReport,
      setTotalRows
    ) =>
      getUserShotClassReportActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setUserShotClassReport,
        setTempUserShotClassReport,
        setTotalRows,
        fromDate,
        reportMode,
        toDate,
        selectedTrainings,
        userId
      ),
    pageSize
  );

  const handleUserPopUp = useCallback((userId) => {
    setUserId(userId);
    handleModalSearchQuery("");
  }, []);

  let userName = "";
  data?.map((i) => {
    if (i.UserId === userId) {
      userName = i.UserName;
    }
  });

  const handleUserClassData = () => {
    handleUserPopUp(0);
  };

  useEffect(() => {
    let newTableColumns = columns(navigate, handleUserPopUp);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleUserPopUp]);

  const onInputChange = (e) => {
    if (e.target.value) setUser(e.target.value);
    else setUser("none");
  };

  const onFilterSearch = (e) => {
    handleSearchQuery();
  };

  const handleReset = () => {
    setUser("none");
    setSelctedTrainings("none");
    setFromDate("none");
    setToDate("none");
    setSelectedTrainingIds("none");
    setToMinDate();
    setFromMinDate();
    setFromMaxDate(dateFormatyyyymmdd(new Date()));
    setToMaxDate(dateFormatyyyymmdd(new Date()));
    handleSearchQuery();
    reset();
    setUpdatedTrainingList(trainingTypes);
  };

  const onFromDateChange = (date) => {
    if (date.target.value) setToMinDate(date.target.value);
    // setFromDate(moment(new Date(date.target.value)).format("DD/MM/YYYY"));
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    setFromDate(newDate + " ");
    // setFromDate(encodeURIComponent(newDate + ""));
  };

  const onToDateChange = (date) => {
    if (date.target.value) setFromMaxDate(date.target.value);
    // setToDate(moment(new Date(date.target.value)).format("DD/MM/YYYY"));
    const newDate = moment(date.target.value).format("DD/MM/YYYY");
    setToDate(" " + newDate);
    // setToDate(encodeURIComponent(newDate + ""));
  };

  const handleClick = () => {
    dispatch(
      getUserDistributionReportActionHandler(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        fromDate,
        toDate,
        user,
        selectedTrainings,
        "Extract",
        setLoader
      )
    );
  };

  const handleModalClick = () => {
    dispatch(
      getUserShotClassReportActionHandler(
        "",
        pageNumber,
        pageSize,
        "",
        "",
        "",
        fromDate,
        "Extract",
        toDate,
        selectedTrainings,
        userId
      )
    );
  };

  //mukesh Training Types

  const [trainingTypesList, setTrainingTypesList] = useState([]);
  let setUpdatedTrainingList = useCallback(
    (trainingTypes) => {
      if (trainingTypes?.length > 0) {
        let updatedUserGroup = trainingTypes.map((userGroup) => {
          return { ...userGroup, isVisible: true };
        });
        setTrainingTypesList(updatedUserGroup);
      }
    },
    [trainingTypes, trainingTypesList]
  );
  useEffect(() => {
    setUpdatedTrainingList(trainingTypes);
  }, [dispatch, trainingTypes]);

  useEffect(() => {
    if (trainingTypesList.length > 0) {
      const filtered = trainingTypesList.filter((item) => {
        return item.checked === true;
      });
      if (filtered.length > 0) {
        let updateFilteredResult = filtered.map((item) => {
          return { label: item.Name, value: item.TypeId };
        });
        setSelctedTrainings(updateFilteredResult);
        let trainingTypeSelected = "";
        filtered?.forEach((data, index) => {
          trainingTypeSelected = `${trainingTypeSelected + data?.TypeId}${
            filtered?.length !== index + 1 ? "," : ""
          }`;
        });
        setSelectedTrainingIds(trainingTypeSelected);
        setSelctedTrainings(trainingTypeSelected);
      }
    }
  }, [trainingTypesList, setSelctedTrainings]);
  return (
    <>
      <div className={classes.reportFilter_Main}>
        <FormProvider {...methods}>
          <div className={classes.reportFilter_userCLass}>
            <Input
              name="userName"
              type={"text"}
              placeholder={intl.formatMessage({
                id: `USER_NAME_TEXT`,
              })}
              label={<FormattedMessage id="REPORT_USERNAME_TXT" />}
              onChange={onInputChange}
              width="25"
            />
            <Input
              name="fromDate"
              label={"From Date"}
              type={"date"}
              onChange={onFromDateChange}
              width="25"
              min={fromMinDate}
              max={fromMaxDate}
            />
            <Input
              name="toDate"
              label={"To Date"}
              type={"date"}
              min={toMinDate}
              max={toMaxDate}
              onChange={onToDateChange}
              width="25"
            />
            <div className={classes.trainingType}>
              <div className={classes.trainingType}>
                {/* <Dropdown
                  label={<FormattedMessage id="TRAINING_TYPE" />}
                  isMulti
                  defaultValue={selectedTrainings}
                  placeholder="Enter Training"
                  options={trainingTypesOptions}
                  onChange={onTrainingSelected}
                  selectedValue={selectedTrainings}
                /> */}
                <InputHookForm
                  label={<FormattedMessage id="TRAINING_TYPE_TEXT" />}
                  name="TrainingTypes"
                  type="noSearchTags"
                  fieldName={"Name"}
                  fieldValue="TypeId"
                  placeholder="Search Training Types"
                  // labelMsg="(Max: 15 Training Types)"
                  height="3.9"
                  width="24.5"
                  labelColor={"#404040"}
                  searchable={true}
                  id={"TypeId"}
                  searchTagsList={trainingTypesList}
                  handleTagList={(tagsList) => {
                    setTrainingTypesList(tagsList);
                  }}
                  // error={errors?.TrainingTypes?.message}
                />
              </div>
            </div>
          </div>
          <div className={classes.searchResetButton}>
            <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "12px",
              }}
              onClick={handleReset}
            >
              <FormattedMessage id="Report_Reset_btn" />
            </span>
            <Button
              label={<FormattedMessage id="P_Search" />}
              dark
              small
              className={classes.searchButton}
              onClick={onFilterSearch}
            />
          </div>
        </FormProvider>
      </div>
      <div className={classes.tabularDataTable}>
        <DataTable
          columns={tableColumns}
          defaultData={data}
          setDefaultData={setData}
          data={updatedData}
          setData={setUpdatedData}
          totalRows={totalRows}
          uniqueFieldName={"UserName"}
          onDownload={() => handleClick()}
          downloadable
          loading={loading}
          fetchMoreData={handleCurrentPage}
        />
        <Modal
          handleSubmit={handleUserClassData}
          isOpen={userId}
          heading={"User Report Details"}
          toggle={() => handleUserPopUp()}
          width={"100"}
          height={"auto"}
        >
          <div>
            <div className={classes.mainHeadingModal}>
              <h3>
                <FormattedMessage id="USER_NAME_TEXT" />:
              </h3>{" "}
              <p className={classes.userName}>{userName}</p>
            </div>
            <DataTable
              columns={modalColumns(navigate)}
              // defaultData={data}
              // setDefaultData={setData}
              data={modalData}
              // setData={setUpdatedData}
              totalRows={setModalTotalRows}
              uniqueFieldName={"ClassName"}
              onDownload={handleModalClick}
              fetchMoreData={handlerModalCurrentPage}
              downloadable
            />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default injectIntl(UserTabularReport);
